// The line above the shrine's box, from the count the gate keeps (lib/notesAllowance.js, sent by /api/role as `notes`).
// Pure, so the page and the tests read the same words. It said "(as he knows you now, 3 in a day.)" from the rung they
// stand on now, and people were held at two (Sam, 2 Nov): the gate keeps yesterday's rung and the last 24 hours.

/**
 * notes: { allowance, left, opensAt?, soon? } or null (an older answer: the rung's number, as before).
 * clock: ms -> the time where they are, e.g. "21:10".
 */
export function notesLine(notes, rungAllowance, clock = (at) => new Date(at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })) {
  if (!notes || typeof notes.allowance !== 'number') return `(as he knows you now, ${rungAllowance} in a day.)`
  const a = `as he knows you now, ${notes.allowance} in a day${notes.soon ? `, ${notes.soon} by this time tomorrow` : ''}`
  if (notes.left > 0) return `(${a}. you have ${notes.left} left.)`
  const at = Number(notes.opensAt)
  return Number.isFinite(at) && at > Date.now() ? `(${a}. your next one opens at ${clock(at)}.)` : `(${a}. none left just now.)`
}
